import {
  FETCH_SOCIAL_FEED,
  FETCH_SOCIAL_FEED_COMMENT,
  SET_SOCIAL_FEED_COMMENT,
  OPEN_SOCIAL_FEED_IMAGE,
  OPEN_SOCIAL_POST_ADD,
  FETCH_SOCIAL_FEED_LIKE
} from '../actions';

export function socialFeed(state = [], action) {
  switch (action.type) {
    case FETCH_SOCIAL_FEED:
      return action.payload;
    default:
      return state;
  }
}

export function feedComment(state = [], action) {
  switch (action.type) {
    case FETCH_SOCIAL_FEED_COMMENT:
      return action.payload;
    default:
      return state;
  }
}

export function feedCommentModal(state = [], action) {
  switch (action.type) {
    case SET_SOCIAL_FEED_COMMENT:
      return action.payload;
    default:
      return state;
  }
}

export function socialImageSlider(state = [], action) {
  switch (action.type) {
    case OPEN_SOCIAL_FEED_IMAGE:
      return action.payload;
    default:
      return state;
  }
}

export function postAddModal(state = [], action) {
  switch (action.type) {
    case OPEN_SOCIAL_POST_ADD:
      return action.payload;
    default:
      return state;
  }
}

export const feedLike = (state = [], action) => {
  if (action.type == FETCH_SOCIAL_FEED_LIKE) {
    return action.payload;
  }
  return state;
};
